import React from "react";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

const LinkedInPage = (): JSX.Element => <LinkedInCallback />;
export default LinkedInPage;
